import { Injectable } from "@angular/core";
import { IVTableColumn } from "@app/directives/_layout/v-table/_models/IVTableColumn";
import { TranslationService } from "@app/services/translation.service";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class FilterBarService {
    dataChanged = new Subject<void>();
    tableColumnEditorOpen = new Subject<{ open: boolean, tableColumns: IVTableColumn<any>[] }>();

    constructor(private readonly translationService: TranslationService) { }

    createTabDefinition<T>(translationString: string, callback: (item: T) => boolean): { title: string, predicate: (item: T) => boolean } {

        return { title: this.translationService.t(translationString), predicate: callback };
    }

    toggleTableColumnEditor(show: boolean, tableColumns: IVTableColumn<any>[]): void {
        this.tableColumnEditorOpen.next({ open: show, tableColumns });
    }

}
